import React, { Component } from "react";
import Hero from "../components/Hero";
import cartBcg from '../images/cart.jpg';
import CartSection from "../components/CartPage";

export default class CartPage extends Component {
	render() {
		return (
			<div>
				<Hero img={cartBcg} />
				<CartSection />
			</div>
		);
	}
}